// QRチケット(2022.4まででのサンリオ. 終売後削除予定)
export const checkIsOldQrPass = (masterPass) => {
  return masterPass.activation_method == "qr_link";
}